import { useCallback } from 'react'
import ApiService from '../../services/ApiService'

const InteractorWarehouseSearch = () => {
  const warehouseSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/account-user/address-search', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data.items)
        } else {
          callback(null)
        }
      }
      loading(false)
    })
  }, [])

  return { warehouseSearch }
}

export default InteractorWarehouseSearch
